import { render, staticRenderFns } from "./TemplatesHeader.vue?vue&type=template&id=158e8fce&scoped=true&"
var script = {}
import style0 from "./TemplatesHeader.vue?vue&type=style&index=0&id=158e8fce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158e8fce",
  null
  
)

export default component.exports